module.exports = __webpack_public_path__ + "static/media/testing.96880cc9.jpg";